import React, { useState, useEffect } from "react";
import { motion, AnimatePresence } from "framer-motion";

const Preloader: React.FC = () => {
  const [loading, setLoading] = useState(true);
  const [startWipe, setStartWipe] = useState(false);
  const [percent, setPercent] = useState(0);

  useEffect(() => {
    // Percent loader counter
    const interval = setInterval(() => {
      setPercent((prev) => {
        if (prev >= 100) {
          clearInterval(interval);
          setTimeout(() => {
            setStartWipe(true);
            setTimeout(() => {
              setLoading(false);
            }, 900); // Allow time for full staggered animation to complete
          }, 300);
          return 100;
        }
        const nextVal = prev + Math.floor(Math.random() * 18) + 8;
        return nextVal >= 100 ? 100 : nextVal;
      });
    }, 40);

    return () => clearInterval(interval);
  }, []);

  const numStrips = 10;

  return (
    <AnimatePresence>
      {loading && (
        <div className="fixed inset-0 z-[999999] flex flex-col pointer-events-none">
          {/* Percentage Indicator - responsive sizing */}
          <motion.div 
            initial={{ opacity: 1 }}
            animate={startWipe ? { opacity: 0 } : {}}
            transition={{ duration: 0.2 }}
            className="absolute inset-0 flex flex-col items-center justify-center z-[1000000] font-mono gap-3 pointer-events-auto"
            style={{ color: 'var(--t1)' }}
          >
            <svg
              className="w-12 h-12 sm:w-16 sm:h-16 animate-pulse"
              viewBox="0 0 32 32"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
              style={{ color: 'var(--blue)' }}
            >
              <path d="M4 20 L14 8 L18 8 L8 20 Z" fill="currentColor" />
              <path d="M16 20 L26 8 L30 8 L20 20 Z" fill="currentColor" />
            </svg>
            <span className="text-xs sm:text-sm font-bold tracking-[0.2em]">{percent}%</span>
          </motion.div>

          {/* Staggered Vertical columns - responsive scaleY transitions for 100% browser compatibility */}
          <div className="absolute inset-0 flex w-full h-full">
            {Array.from({ length: numStrips }).map((_, i) => (
              <motion.div
                key={i}
                initial={{ scaleY: 1 }}
                animate={startWipe ? { scaleY: 0 } : {}}
                transition={{
                  duration: 0.45,
                  delay: i * 0.04,
                  ease: [0.76, 0, 0.24, 1],
                }}
                className="h-full flex-1"
                style={{ 
                  backgroundColor: "var(--bg)", 
                  transformOrigin: "top",
                  willChange: "transform"
                }}
              />
            ))}
          </div>
        </div>
      )}
    </AnimatePresence>
  );
};

export default Preloader;
